/** Locale codes stored in `tbl_user.language` for app UI (matches `locales/` folders). */
export const UI_LOCALE_OPTIONS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

/**
 * Map DB / legacy values to a supported UI locale code.
 */
export function normalizeUserUiLanguage(stored) {
  if (!stored) return "en";
  const s = String(stored).trim().toLowerCase();
  if (["en", "es", "fr"].includes(s)) return s;
  if (s === "english") return "en";
  if (s === "spanish" || s === "español" || s === "espanol") return "es";
  if (s === "french" || s === "français" || s === "francais") return "fr";
  return "en";
}
